import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./pages/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Careers from "./pages/Careers";
import CaseStudies from "./pages/CaseStudies";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Footer from "./pages/Footer";
import Login from "./pages/Login";
import Industries from "./pages/Industries";
import Education from "./pages/Education";
import Technology from "./pages/Technology";
import Healthcare from "./pages/Healthcare";
import Government from "./pages/Government";
import Hospitality from "./pages/Hospitality";
import ProfessionalServices from "./pages/ProfessionalServices";
import Ecommerce from "./pages/Ecommerce";
import WhatsAppChat from "./pages/WhatsAppChat";
import CEO from "./pages/CEO";
import ScrollToTop from "./components/ScrollToTop";
import SoftwareWebEngineering   from "./components/SoftwareandWebEngineering";
import DataCollection from "./components/DataCollection";
import PDFDataIDP from "./components/PDFDataIDP";
import AIMachineLearning from "./components/AIMachineLearning";
import CloudDevOps from "./components/CloudDevOps";
import JavaFullStack from "./components/JavaFullStack";
import MobileApplication from "./components/MobileApplication";
import UIDesign from "./components/UIDesign";
import AIDesign from "./components/AIDesign";
/* services subpages*/
import AIWorkFilm from "./pages/AIWork&Film";
import ITServicesPage from "./pages/ITServices";
import CloudPlatformsPage from "./pages/CloudPlatforms";
import CyberSecurityPage from "./pages/CyberSecurity";
import DigitalMarketingPage from "./pages/DigitalMarketing";
import BPOServicesPage from "./pages/BPOServices";
import HRPayrollServicesPage from "./pages/HR&payroll";
import ManPoweringPage from "./pages/ManPowering";
import InternshipTrainingPage from "./pages/Internship&Training";
import CAFinancialServicesPage from "./pages/CA&FinancialServices";
import "./styles/ServicePalette.css";
import "./styles/SiteTypography.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppLayout />
    </Router>
  );
}

function AppLayout() {
  return (
    <>
      <Navbar />
      <WhatsAppChat />
      <main>
       <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        {/*<Route path="/service/:serviceSlug" element={<CourseDetails />} />*/}
        <Route path="/services/it-services" element={<ITServicesPage />} />
        <Route path="/services/ai-work-film" element={<AIWorkFilm />} />
        <Route path="/services/cloud-platforms" element={<CloudPlatformsPage />} />
        <Route path="/services/cyber-security" element={<CyberSecurityPage />} />
        <Route path="/services/digital-marketing" element={<DigitalMarketingPage />} />
        <Route path="/services/bpo" element={<BPOServicesPage />} />
        <Route path="/services/hr-payroll" element={<HRPayrollServicesPage />} />
        <Route path="/services/manpowering" element={<ManPoweringPage />} />
        <Route path="/services/internship-training" element={<InternshipTrainingPage />} />
        <Route path="/services/ca-financial-services" element={<CAFinancialServicesPage />} />

        <Route path="/ITServices" element={<Navigate to="/services/it-services" replace />} />
        <Route path="/ai-work-film" element={<Navigate to="/services/ai-work-film" replace />} />
        <Route path="/cloud-platform" element={<Navigate to="/services/cloud-platforms" replace />} />
        <Route path="/cyber-security" element={<Navigate to="/services/cyber-security" replace />} />
        <Route path="/digital-marketing" element={<Navigate to="/services/digital-marketing" replace />} />
        <Route path="/bpo-services" element={<Navigate to="/services/bpo" replace />} />
        <Route path="/hr-payroll-services" element={<Navigate to="/services/hr-payroll" replace />} />
        <Route path="/man-powering" element={<Navigate to="/services/manpowering" replace />} />
        <Route path="/internship-training" element={<Navigate to="/services/internship-training" replace />} />
        <Route path="/ca-financial-services" element={<Navigate to="/services/ca-financial-services" replace />} />
        
        <Route path="/services/software-web-engineering" element={<SoftwareWebEngineering />} />
        <Route path="/services/data-collection" element={<DataCollection />} />
        <Route path="/services/pdf-data-idp" element={<PDFDataIDP/>}/>
        <Route path="/services/ai-machine-learning" element={<AIMachineLearning />} />
        <Route path="/services/cloud-devops" element={<CloudDevOps />} />
        <Route path="/services/java-full-stack" element={<JavaFullStack />} />
        <Route path="/services/mobile-application" element={<MobileApplication />} />
        <Route path="/services/ui-ux-design" element={<UIDesign />} />
        <Route path="/services/ai-product-design" element={<AIDesign />} />

        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/education" element={<Education />} />
        <Route path="/industries/technology" element={<Technology />} />
        <Route path="/industries/healthcare" element={<Healthcare />} />
        <Route path="/industries/government" element={<Government />} />
        <Route path="/industries/hospitality" element={<Hospitality />} />
        <Route path="/industries/professional-services" element={<ProfessionalServices />} />
        <Route path="/industries/ecommerce" element={<Ecommerce />} />
        <Route path="/ecommerce" element={<Ecommerce />} />
        <Route path="/education" element={<Education />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/healthcare" element={<Healthcare />} />
        <Route path="/government" element={<Government />} />
        <Route path="/hospitality" element={<Hospitality />} />
        <Route path="/professional-services" element={<ProfessionalServices />} />

        <Route path="/career" element={<Careers />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/CEO" element={<CEO />} />
        <Route path="*" element={<Navigate to="/" replace />} />


      </Routes>
      </main>

      <Footer />
    </>
  );
}

export default App;